// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\np.app-settings span.icon-loading-small[data-v-063bfcee] {\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tpadding: 5px 0;\n}\np.app-settings[data-v-063bfcee] {\n\tpadding: 10px 0;\n}\n.app-settings-button[data-v-063bfcee] {\n\tdisplay: block;\n\tpadding-left: 34px;\n\tbackground-position: 10px center;\n}\n.app-settings-link[data-v-063bfcee] {\n\ttext-decoration: underline;\n}\n", ""]);
// Exports
module.exports = exports;
